<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <div>
      <div class="container mt-5 pt-5" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: green;font-family: Open Sans, sans-serif;font-size:25px!important;">
            <span><v-icon class="mr-1" color="green">&#xe92d;</v-icon></span>
            <span style="padding-top: 2px">{{ $t('contrat.payment_contrat.title') }}</span>
          </p>
        </div>

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="row" style="background:#FAFAFA;padding-top: 20px!important">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../assets//img/assuraf_lg.png" width="80" alt="assuraf_logo">
                                </div>
                              </div>
                                <i class="fa fa-check-circle mt-5" aria-hidden="true"></i>
                                <h2>{{ $t('contrat.payment_contrat.payment_ok_title') }}</h2>
                                <p>{{ $t('contrat.payment_contrat.thank_you_message[0]') }}<br>
                                  {{ $t('contrat.payment_contrat.thank_you_message[1]') }}<br>{{ $t('contrat.payment_contrat.thank_you_message[2]') }}<br><br>
                                  </p> 
                                  <p class="mt-3"><span class="attestation-content">{{ $t('contrat.payment_contrat.number_contrat_label') }} <span class="font-weight-bold">{{numerodevis}}</span></span></p>
                                  

                                  
                                  <div class="row mt-5 justify-content-between" style="margin-bottom: -40px;">
                                    <div class="col-md-6">
                                      
                                      <div class="mt-2 justify-content-start row">
                                        <p style="margin-top: 5px!important;">{{ $t('contrat.payment_contrat.share_to_social_network_label') }} </p>
                                        <ShareNetwork class="ml-3" network="facebook" url="https://www.assuraf.com" :quote="$t('contrat.payment_contrat.partage_content')">
                                          <img src="../assets/img/thankPagesSocialIcon/facebook.png" alt="facebook logo" width="30">
                                        </ShareNetwork>

                                        <ShareNetwork class="ml-2" network="twitter" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')">
                                          <img src="../assets/img/thankPagesSocialIcon/twitter.png" alt="twitter logo" width="40">
                                        </ShareNetwork>

                                        <ShareNetwork class="ml-2" network="linkedIn" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')" :quote="$t('contrat.payment_contrat.partage_content')">
                                          <img src="../assets/img/thankPagesSocialIcon/linkedIn.png" alt="linkedin logo" width="35">
                                        </ShareNetwork>

                                        <ShareNetwork class="ml-3" network="whatsapp" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')">
                                          <img src="../assets/img/thankPagesSocialIcon/whatsapp.png" alt="wahtsapp logo" width="30" style="margin-top:2px">
                                        </ShareNetwork>
                                      </div>
                                    </div>

                                    <div class="col-md-6 text-right">
                                      
                                      <div class="mt-2 justify-content-end row">
                                        <p style="margin-top: 5px!important;">{{ $t('contrat.payment_contrat.text_to_whatsapp_label') }} </p>
                                        <a href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋" target="_blank" rel="nofollow noopener noreferrer">
                                          <img class="ml-3" src="../assets/img/thankPagesSocialIcon/whatsapp_grey.png" alt="grey whatsapp logo" width="30" style="margin-top:1px">
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                            </div> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE       ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="mt-5 row" style="background:#FAFAFA;padding-top: 40px!important">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../assets//img/assuraf_lg.png" width="80" alt="assuraf_logo">
                                </div>
                              </div>
                                <i class="fa fa-check-circle mt-5" aria-hidden="true"></i>
                                <h2>{{ $t('contrat.payment_contrat.payment_ok_title') }}</h2>
                                <p>{{ $t('contrat.payment_contrat.thank_you_message[0]') }}<br>
                                  {{ $t('contrat.payment_contrat.thank_you_message[1]') }}<br>{{ $t('contrat.payment_contrat.thank_you_message[2]') }}<br><br>
                                  </p> 
                                  <p class="mt-2">
                                    <span>{{ $t('contrat.payment_contrat.number_contrat_label') }}</span> <br><br><span class="attestation-content font-weight-bold">{{numerodevis}}</span></p>
                                  

                                  
                                  <div class="justify-content-center row mt-5">
                                    <p style="margin-top: 8px;">{{ $t('contrat.payment_contrat.share_to_social_network_label') }} </p>
                                  </div> 
                                  <div class="mt-2 justify-content-center row">
                                    <ShareNetwork network="facebook" url="https://www.assuraf.com" :quote="$t('contrat.payment_contrat.partage_content')">
                                        <img src="../assets/img/thankPagesSocialIcon/facebook.png" alt="facebook logo" width="25">
                                      </ShareNetwork>

                                      <ShareNetwork class="ml-2" network="twitter" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')">
                                        <img src="../assets/img/thankPagesSocialIcon/twitter.png" alt="twitter logo" width="35">
                                      </ShareNetwork>

                                      <ShareNetwork class="ml-2" network="linkedIn" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')" :quote="$t('contrat.payment_contrat.partage_content')">
                                        <img src="../assets/img/thankPagesSocialIcon/linkedIn.png" alt="linkedIn logo" width="30">
                                      </ShareNetwork>

                                      <ShareNetwork class="ml-3" network="whatsapp" url="https://www.assuraf.com" :title="$t('contrat.payment_contrat.partage_content')">
                                        <img src="../assets/img/thankPagesSocialIcon/whatsapp.png" alt="whatsapp logo" width="25" style="margin-top:2px">
                                      </ShareNetwork>
                                  </div>
                                  
                                  <div class="justify-content-center row">
                                    <p style="margin-top: 8px;">{{ $t('contrat.payment_contrat.text_to_whatsapp_label') }} </p>
                                  </div> 
                                  <div class="mt-2 justify-content-center row" style="margin-bottom: -30px;">
                                    <a href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋" target="_blank" rel="nofollow noopener noreferrer">
                                          <img class="ml-3" src="../assets/img/thankPagesSocialIcon/whatsapp_grey.png" alt="grey whatsapp logo" width="30" style="margin-top:1px">
                                        </a>
                                </div>
                            </div> 
                        </div>    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal loader start-->
        <!-- Modal loader start-->
        <!-- Modal loader start-->

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('paiement.sante.popup_file_generator.title') }}</span>
    </div>

        <!-- <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
          <v-card color="orange" dark>
            <v-card-text>
              {{ $t('paiement.sante.popup_file_generator.title') }}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog> -->
      </div>
    </div>
  </div>
</template>


<script>
import AnchorRouterLink from "vue-anchor-router-link";
import Api from "../services/Api";
import lib from '../libs/index'

const sonam ='SONAM GENERALE ASSURANCES'
export default {
  data() {
    return {
      numerodevis : null,
      urlWhatsapp : null,
      components: {
        AnchorRouterLink
      },
      dialogLoading: false,
      Contrat_provisoire: null, // le contrat
      user_info: null, // le user depuis le store

      ToastTabSucess: {
        // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 2000,
        fitToScreen: true,
        type: "success",
        className: "custom-success-class"
      },
      ToastTabError: {
        // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 2000,
        fitToScreen: true,
        type: "error"
      }
    };
  },
  methods: {
    Redirection: function (page) {
      if (page) {
        this.$router.push("/" + page);
      } else {
        this.$router.push("/");
      }
    },


  },
  beforeDestroy() {
    if (window.history && window.history.pushState) {
      this.$router.push("/");
    }

  },
  mounted() {
    window.scrollTo(0, 0);
    const params = new URLSearchParams (window.location.search)
      this.numerodevis = params.get('mdoi').replace(/[_]/g, '/').substring(7)
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";
@import "../assets/css/assurcare/form_assurcare.css";

.rowBanner {
  padding: auto;
  background-image: url("../assets/img/thankPagesSocialIcon/banner.png  ");
  background-size: 100% 100%;
  height: auto;
  opacity: 2;
}

.rowBanner-mobile {
  padding: auto;
  background-image: url("../assets/img/thankPagesSocialIcon/banner-mobile.png  ");
  background-size: 100% 100%;
  height: auto;
  opacity: 2;
}

.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}

.row-container {
  background: white;
}

.border-radius {
  border-radius: 20px;
}

.georgia {
  font-family: Georgia !important;
}






._failed{ border-bottom: solid 4px red !important; }
._failed i{  color:red !important;  }

._success {
  background-color: rgb(255, 251, 246);;
    border-radius: 10px;
    box-shadow: 0 15px 25px #00000019;
    padding: 45px;
    width: 100%;
    text-align: center;
    margin: 40px auto;
    // border-bottom: solid 4px #28a745;
    border-bottom: solid 4px #ffa409;
}

._success i {
    font-size: 55px;
    color: #28a745;
}

._success h2 {
    margin-bottom: 12px;
    font-size: 30px;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 10px;
}

._success p {
    margin-bottom: 0px;
    font-size: 15px;
    color: #000;
    font-weight: 500;
}
.attestation-content {
    border: 1px solid;
    padding: 15px;
    border-radius: 10px;
    background: #fff;
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>

